// The convention for integrator/public API events is to use PascalCase
// internal uses camelCase.
// Api Events are publically "advertised" events.
export var ApiEvents;
(function (ApiEvents) {
    ApiEvents["CONNECTION_STATUS_EVENT"] = "ConnectionStatusEvent";
    ApiEvents["ECDN10_PROGRESS"] = "LegacyProgress";
    ApiEvents["ERROR"] = "KsdkError";
    ApiEvents["INFO"] = "KsdkInfo";
    ApiEvents["IP_TYPE"] = "NetworkType";
    ApiEvents["PLAYBACK_STATUS_CHANGE"] = "PlaybackStatusChange";
    ApiEvents["SOURCES_READY"] = "SourcesReady";
    ApiEvents["START_DELIVERY_FINISHED"] = "StartDeliveryFinished";
    ApiEvents["WEBSOCKET_CONNECT"] = "WebsocketConnect";
})(ApiEvents || (ApiEvents = {}));
export var DeprecatedEvents;
(function (DeprecatedEvents) {
    // Deprecated in favor of IP_TYPE
    DeprecatedEvents["IP_MDNS"] = "ip.mdns";
    // Deprecated in favor ECDN10_PROGRESS
    DeprecatedEvents["LEGACY_PROGRESS"] = "legacy.progress";
    // Deprecated in favor of WEBSOCKET_CONNECT
    DeprecatedEvents["WEBSOCKET_CONNECTION"] = "websocket.connect";
})(DeprecatedEvents || (DeprecatedEvents = {}));
export var ConnectionChangeState;
(function (ConnectionChangeState) {
    ConnectionChangeState["CLOSE"] = "close";
    ConnectionChangeState["ERROR"] = "error";
    ConnectionChangeState["INITIALIZED"] = "initialized";
    ConnectionChangeState["OPEN"] = "open";
    ConnectionChangeState["PEER_CONFIGURED"] = "peerconfigured";
    ConnectionChangeState["RECONNECT"] = "reconnect";
    ConnectionChangeState["SHUTDOWN"] = "shutdown";
})(ConnectionChangeState || (ConnectionChangeState = {}));
